import { SidebarNavItemsProps } from '@/sidebar/presentation/components/NavigationItem';
import { Typography } from '@creditas-ui/typography';
import { Item } from './MenuItem.style';
import { VerticalRightArrowIcon } from './icons/VerticalRightArrowIcon';

type MenuItemProps = {
  item: SidebarNavItemsProps;
  onItemClick: (item: SidebarNavItemsProps) => void;
};

export const MenuItem = ({ item, onItemClick }: MenuItemProps): JSX.Element => {
  return (
    <Item onClick={() => onItemClick(item)} data-testid="menu-item-button">
      <Typography variant="bodyMdRegular" color="neutral.90">
        {item.name}
      </Typography>
      <VerticalRightArrowIcon data-testid="menu-item-icon" />
    </Item>
  );
};
